import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useErrorReporting } from '../../context';
import { ErrorPage } from '../ErrorPage';
export const ErrorBoundary = ({ children, tags, mfe, team }) => {
    const errorReporting = useErrorReporting();
    const onError = (error, info) => {
        if (errorReporting) {
            const renderingError = new Error(error.message);
            renderingError.name = 'DashboardRenderingError';
            renderingError.stack = info.componentStack;
            renderingError.cause = error;
            let context = { mfe, team };
            if (tags) {
                context = { ...tags, mfe, team };
            }
            errorReporting.datadog.addError(renderingError, context);
        }
    };
    return (React.createElement(ReactErrorBoundary, { fallback: React.createElement(ErrorPage, null), onError: onError }, children));
};
